<template>
    <div class="h-100 w-100" v-if="routed">
        <AnimateIcon type="success">{{ meg }}</AnimateIcon>
    </div>
</template>

<script>
import EmCommonApi from "@/mixin/em/common/api";
import AnimateIcon from "../echarts-part/AnimateIcon/AnimateIcon";

export default {
    name: "OpenIdInitPage",
    components: {AnimateIcon},
    mixins: [EmCommonApi],
    data() {
        return {
            meg: '绑定成功',
            routed: false,
            baseUrl: process.env.VUE_APP_SITHMES_OUTSIDE
        }
    },
    created() {
        this.setVisible(false)
    },
    mounted() {
        this.initAuthInfo()
    },
    destroyed() {
        if (!this.routed) {
            this.setVisible(true);
        }
    },
    methods: {
        setVisible(visibility) {
            this.$store.commit("base/setShowHeader", visibility, {root: true});
            this.$store.commit("base/setShowSidebar", visibility, {root: true});
        },
        initAuthInfo() {
            let returnJson = JSON.parse(decodeURIComponent(localStorage['url_return_json']));
            let _api = process.env.VUE_APP_EM_ASSISTANT_URL + '/wx/auth';
            this.$_emApiMixin_post(_api, {
                code: returnJson.code
            }).then(data => {
                console.log(data)
                let value = data.data
                if (value.code < 300) {
                    this.meg = value.msg;
                    this.$message({
                        message: value.msg,
                        type: 'success'
                    });
                    // this.routed = true;
                    // let params = value.state === undefined ? '' : '?taskId=' + value.state;
                    // setTimeout(() => {
                    //     this.$router.push('/wx/andon/list' + params);
                    // }, 2000);
                } else {
                    this.meg = value.msg;
                    this.$message.error(value.msg);
                }
            })
        }
    }
}
</script>

<style scoped>

</style>
